export type ModelTier = 'premium' | 'standard';

/**
 * Premium (higher-cost) model families — everything else is standard tier.
 * Mirrors the insights `PREMIUM_MODEL_SQL` name match so the Behavior page and
 * the Insights model-fit score agree on what counts as a premium model.
 */
const PREMIUM_PATTERNS = ['pro', 'opus', 'gpt-5', 'grok', 'ultra'];

export function isPremiumModel(model: string): boolean {
    const lower = model.toLowerCase();
    return PREMIUM_PATTERNS.some((pattern) => lower.includes(pattern));
}

export function modelTier(model: string): ModelTier {
    return isPremiumModel(model) ? 'premium' : 'standard';
}
